import {Text, Overlay} from 'src/v2/components/common';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {useSelector} from 'src/v2/state/store';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';
import {message, useIntl} from '@sail/intl';

const messages = {
  confirm: message({
    id: 'crypto.payins.v2.network_switching.confirm_network_switch',

    description:
      'Prompt to tell the user to confirm the transaction in MetaMask',

    defaultMessage: 'Confirm network update',
  }),
};

export const NetworkSwitchingOverlay = () => {
  const intl = useIntl();
  const activeWallet = useSelector(
    (state) => state.walletConnection.activeWallet,
  );

  if (!activeWallet) {
    throw new Error(
      'activeWallet is required in SetupConfirmationPendingOverlay',
    );
  }

  const walletOption = WalletRegistry.getWalletOption({
    provider: activeWallet.type,
    key: activeWallet.key,
  });

  if (!walletOption) {
    throw new Error('Wallet option not found in NetworkSwitchingOverlay');
  }

  return (
    <Overlay name="network-switching">
      <WalletIcon walletOption={walletOption} />
      <Text type="heading">{intl.formatMessage(messages.confirm)}</Text>
    </Overlay>
  );
};
